export default "__VITE_ASSET__CMoLFEZz__"